import actionTypes from "../../actions/actionTypes";

const _initState = {
  data: {},
};

const header = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_HEADER_TITLE:
      return { ...state, data: { ...state.data, title: action.data } };
    case actionTypes.SHOW_APP_HEADER:
      return { ...state, data: { ...state.data, show: action.data } };

    default:
      return state;
  }
};

export default header;
